export { default as ContentfulLandingPage } from './landing'



// WEBPACK FOOTER //
// ./src/modules/contentful/landing/index.js